export interface ExportColumn {
  header: string;
  key: string;
}

export const getExportColumns = (lang: string): ExportColumn[] => {
  const langUpper = lang.toUpperCase();

  return [
    { header: "questionNumber", key: "questionNumber" },
    { header: `group${langUpper}`, key: "group" },
    { header: "groupEN", key: "groupEN" },
    { header: `question${langUpper}`, key: "question" },
    { header: "questionEN", key: "questionEN" },
    { header: "id", key: "id" },
    { header: "value", key: "value" },
    { header: "units", key: "units" },
    { header: "type", key: "type" },
    { header: "notes", key: "notes" },
    { header: "files", key: "files" },
    { header: "isVisible", key: "isVisible" },
    { header: "parentQuestionCode", key: "parentQuestionCode" },
    { header: "rowIndex", key: "rowIndex" },
  ];
};
